// TODO: Why do we need to define this? - should be in yaml
export var CoverName;
(function (CoverName) {
    CoverName["_03_0_IU_PermDis"] = "03.0_IU_PermDisability";
    CoverName["_03_0_IU_Accident"] = "03.0_IU_AccidentCosts";
    CoverName["_03_0_IU_Death"] = "03.0_IU_Death";
    CoverName["_03_0_IU_childAdvantage"] = "03.0_IU_ChildBenefit";
    CoverName["_01_0_AH_Basic"] = "01.0_AH_Basic";
    CoverName["_01_0_AH_SumInsuredProperty"] = "01.0_AH_SumInsuredProperty";
    CoverName["_01_0_AH_passengerVariant"] = "01.0_AH_passengerVariant";
    CoverName["_01_0_AH_exemptionFromMotorTax"] = "01.0_AH_exemptionFromMotorTax";
    CoverName["_01_0_AH_ForeignPlus"] = "01.0_AH_ForeignPlus";
    CoverName["_04_0_AS_basicAssistance"] = "04.0_AS_Basic";
    CoverName["_01_0_AH_rentalCar"] = "01.0_AH_rentalCar";
})(CoverName || (CoverName = {}));
export var ProductName;
(function (ProductName) {
    ProductName["NMP"] = "nmp";
    ProductName["WHEELY"] = "wheely";
    ProductName["LEGALEXPENSES"] = "legalExpenses";
})(ProductName || (ProductName = {}));
